/* eslint-disable camelcase */
import { trackClick } from ".";
import ChaptersEnum from "./enums/chapters";
import LevelsEnum from "./enums/levels";
import ClickTypes from "./enums/click-types";
import ClicksEnum from "./enums/clicks";

// Clicks tracking

export function trackClickButtonSubscribe() {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: ClicksEnum.Subscribe,
    click_chapter1: ChaptersEnum.Home,
    site_level2: LevelsEnum.Home,
  });
}

export function trackClickButtonLogin() {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: ClicksEnum.Login,
    click_chapter1: ChaptersEnum.Home,
    site_level2: LevelsEnum.Home,
  });
}
